/**
 * Sizing interface
 * @property {string} STANDARD - standard size
 * @property {string} COMPACT - compact size
 * @property {string} LARGE_LOGO - large logo size
 */
export var layoutSizes;
(function (layoutSizes) {
    layoutSizes["STANDARD"] = "standard";
    layoutSizes["COMPACT"] = "compact";
    layoutSizes["LARGE_LOGO"] = "large-logo";
})(layoutSizes || (layoutSizes = {}));
/**
 * Available Address Layouts / Formats
 *
 * @property INLINE - Information provided will display as example below
 *
 * {Retailer} {StoreID} {Street} {City, State Zip} {Button}
 *
 * @property STACKED - Information provided will display as example below
 *
 * {Retailer} {StoreID}
 *
 * {Street}
 *
 * {City, State Zip}
 *
 * {Button}
 *
 * @property MIXED - Information provided will display as example below
 *
 * {Retailer} {StoreID} {Street}
 *
 * {City, State Zip}
 *
 * {Button}
 */
export var sharedAddressComponentLayout;
(function (sharedAddressComponentLayout) {
    sharedAddressComponentLayout["INLINE"] = "prx-address--inline";
    sharedAddressComponentLayout["STACKED"] = "prx-address--stacked";
    sharedAddressComponentLayout["MIXED"] = "prx-address--mixed";
})(sharedAddressComponentLayout || (sharedAddressComponentLayout = {}));
